<span [class]="badgeClasses()" data-testid="status-badge">{{ displayLabel() }}</span>
